const data = [
  {
    id: 0,
    title: "Hive",
    youtubeLink: "https://www.youtube.com/watch?v=TnRcWefnP1w",
    gitLink: "",
    siteLink: "",
    description:
      "A react native dating app based on user location and nearby places.",
  },
  {
    id: 1,
    title: "Simon",
    youtubeLink: "https://www.youtube.com/watch?v=U9d-g6E4xdk&t=5s",
    gitLink: "https://github.com/ShellyAmbar/SymonSaysGame",
    siteLink:
      "https://play.google.com/store/apps/details?id=com.shellyambar.SimonSays",
    description:
      "A react native game with more then 500 downloads, using custom hooks,redux toolkit with thunk middleware.",
  },
  {
    id: 2,
    title: "Dateroulette - video-calling dating app",
    youtubeLink: "https://www.youtube.com/shorts/7NJSammxonk",
    gitLink: "",
    siteLink:
      "https://play.google.com/store/apps/details?id=com.shellyapps.hive",
    description:
      "A react native video-calling dating app with chats,AR backgrounds during video using webrtc,mobx,firebase.",
  },
  {
    id: 3,
    title: "Portofilio in React",
    youtubeLink:
      "https://www.youtube.com/watch?v=bKAjkQCHIjc&ab_channel=ShellyAmbar",
    gitLink: "https://github.com/ShellyAmbar/ShellyApps-website",
    siteLink: "",
    description:
      "Full responsive react js web application. Contain Scroll Animations and Pure CSS design",
  },
  {
    id: 4,
    title: "ResuMe in React & Firebase",
    youtubeLink:
      "https://www.youtube.com/watch?v=n3dkZn22RCk&ab_channel=ShellyAmbar",
    gitLink: "https://github.com/ShellyAmbar/RezuMe",
    siteLink: "",
    description:
      "A fullstack website in React & Firebase, Helping creating resume website for everyone.",
  },
  {
    id: 5,
    title: "Save Jack! - Android with Java",
    youtubeLink:
      "https://www.youtube.com/watch?v=c6Xtv2G4Hto&ab_channel=ShellyAmbar",
    gitLink:
      "https://github.com/ShellyAmbar/Save-Jack/tree/master/java/com/shellyambar/thegame",
    siteLink: "",
    description: "A trivia game in Java with Android Studio.",
  },
  {
    id: 6,
    title: "Employees Maneger App - Fullstack React Native & Node js",
    youtubeLink: "https://youtu.be/XoPsO2fu6Wg",
    gitLink: "https://github.com/ShellyAmbar/EmployeesManegerApp",
    siteLink: "",
    description: "",
  },
  {
    id: 7,
    title: "ChatUp - social media in java for Android",
    youtubeLink: "https://youtu.be/Grl5EwpIugg",
    gitLink: "https://github.com/ShellyAmbar/ChatUp",
    siteLink: "",
    description: "Combining Instegram & Tinder togeter and get ChatUp!",
  },
  {
    id: 8,
    title: "Food Delivery - React Native app",
    youtubeLink: "https://youtu.be/lTa_OquFF-M",
    gitLink: "https://github.com/ShellyAmbar/FoodDeliveryApp---React-Native",
    siteLInk: "",
    description: "React Native ui Animations Login and SignUp pages.",
  },
  {
    id: 9,
    title: "Wolt clone in Java for Android",
    youtubeLink: "https://youtu.be/CYiRvywhCxE",
    gitLink: "",
    siteLink: "",
    description: "",
  },
  {
    id: 10,
    title: "News App in React Native & Redux Saga",
    youtubeLink: "https://youtu.be/uv0F6OxjlR4",
    gitLink: "https://github.com/ShellyAmbar/NewsApp-ReactNative-Redux",
    siteLink: "",
    description: "",
  },
  {
    id: 11,
    title: "'Story' featcher from scretch for Yupp App",
    youtubeLink: "https://youtu.be/lQ-GDdZxg3s",
    gitLink: "https://github.com/ShellyAmbar/StoriesProgressViewForPager",
    siteLink: "",
    description: "",
  },

  {
    id: 12,
    title: "DateRoulatte - FullStack React & Node js app using Socket.io",
    youtubeLink: "https://www.youtube.com/watch?v=UJJBVhlO6-Y",
    gitLink:
      "https://github.com/ShellyAmbar/DateRoulatte---React-Node-JS-Socket.io",
    siteLink: "",
    description: "Video dating app with socket.io",
  },

  {
    id: 13,
    title: "A 3D game in Unity with C#",
    youtubeLink: "https://www.youtube.com/watch?v=LSgTI-n7Dbc&t=7s",
    gitLink: "",
    siteLink:
      "https://play.google.com/store/apps/details?id=com.ShellyApps.HauntedParadise",
    description:
      "A 3D game in Unity with C#, using URP modules, Shaders, Player controller with touch for mobile, 3D physics and OOP.",
  },
];

export {data};
